import { combineReducers } from 'redux';
import { routerReducer as router } from 'react-router-redux';
import { reducer as content } from '../modules/content';
import { reducer as layout } from '../modules/layout';
import { reducer as navigation } from '../modules/navigation';
import { reducer as people } from '../modules/people';
import { reducer as team } from '../modules/team';

const entities = combineReducers({
  content,
  people,
  team,
});

const rootReducer = combineReducers({
  entities,
  layout,
  navigation,
  //parallax,
  router,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js